import SeoArticleLayout from '@/components/feature/SeoArticleLayout';
import { seoArticles } from '@/mocks/seo-articles';

export default function BudgetFindsPage() {
  return <SeoArticleLayout article={seoArticles[0]} />;
}